import { makeCompositeId, splitCompositeId } from '@cbridge-utils/formatters';
import { ISchedule } from '@cbridge-packages/schedule';

export const makeIntervalId = (scheduleId: ISchedule['scheduleId'], index: number) => {
  return makeCompositeId([scheduleId, index]);
};

export const splitIntervalId = (intervalId: string): {
  scheduleId: ISchedule['scheduleId'];
  index: number;
} => {
  const [scheduleId, index] = splitCompositeId(intervalId);

  return {
    scheduleId: Number(scheduleId),
    index: Number(index),
  };
};

export const checkIfIntervalId = (intervalId: string): boolean => {
  const [scheduleId, index] = splitCompositeId(intervalId);

  return index !== undefined && scheduleId !== undefined;
};
